var React = require('react');

function MenuOpen (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"\n    menu-open\n  "),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"CONTENT"},[React.createElement("line",{"x2":"29.04","y1":"1.5","y2":"1.5","fill":"none","stroke":"none","strokeMiterlimit":"10","strokeWidth":"3","key":0}),React.createElement("line",{"x2":"29.04","y1":"9.4","y2":"9.4","fill":"none","stroke":"none","strokeMiterlimit":"10","strokeWidth":"3","key":1}),React.createElement("line",{"x2":"29.04","y1":"17.29","y2":"17.29","fill":"none","stroke":"none","strokeMiterlimit":"10","strokeWidth":"3","key":2})]))]);
}

MenuOpen.defaultProps = {"viewBox":"0 0 29.04 18.79"};

module.exports = MenuOpen;

MenuOpen.default = MenuOpen;
